/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { func, object, string } from 'prop-types';

// Material UI
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
    FormControl, Grid, makeStyles, MenuItem, Select, withStyles, Input,
} from '@material-ui/core';

import { calendarColorStyle } from '../../../Helpers/Style-Helper';

const useStyles = makeStyles(
    (theme) => ({
        formControlRoot: {
            margin: '8px 0',
            '& >div': {
                fontSize: '0.875em',
            },
            '& fieldset': {
                border: 0,
            },
            '& svg': {
                right: 0,
            },
            [theme.breakpoints.down(408)]: {
                margin: '10px 0',
            },
        },
        selectRoot: {
            '&:before, &:hover:before, &:active:before, &:focus:before, &:visited:before': {
                border: '0 !important',
            },
            '&:after, &:hover:after, &:active:after, &:focus:after, &:visited:after': {
                border: '0 !important',
            },
        },
        selectMenu: {
            padding: '2px 0',
            '&:hover, &:focus, &:active, &:visited': {
                backgroundColor: 'transparent',
            },
        },
        menuItem: {
            fontSize: '0.875em',
        },
        selectOutline: {
            color: calendarColorStyle.primary.main,
            padding: '2px 31px 0 0',
            fontWeight: 'normal',
        },
        iconOutlined: {
            top: 'calc(50% - 14px)',
            marginRight: '-2px',
            color: calendarColorStyle.primary[700],
        },
    }),
    { name: 'ShipHolidaysList' },
);

const ShipHolidaysList = ({
    shipHolidayDetails,
    holidaySelected,
    handleSelectHoliday,
}) => {
    const classes = useStyles();

    let holidayValue = holidaySelected;
    if (holidayValue === 'Holiday Delivery') {
        holidayValue = '';
    }

    const getHolidayList = () => {
        const holidayList = Object.keys(shipHolidayDetails).map((code) => {
            const holiday = shipHolidayDetails[code][0];
            return (
                <MenuItem tabIndex={0} className={classes.menuItem} key={holiday.holidayCode} value={holiday.holidayCode}>
                    {holiday.holidayDesc} Delivery
                </MenuItem>
            );
        });
        holidayList.unshift(
            <MenuItem tabIndex={0} key="holidayListEmpty" className={classes.menuItem} value="" disabled>
                Holiday Delivery
            </MenuItem>,
        );
        return holidayList;
    };

    if (Object.keys(shipHolidayDetails)?.length > 0) {
        return (
            <Grid id="holiday-list" container justifyContent="flex-end">
                <FormControl
                    className={classes.formControlRoot}
                >
                    <Select
                        autoWidth
                        input={(
                            <Input
                                className={classes.selectRoot}
                                name="holiday"
                                id="holiday"
                            />
                        )}
                        classes={{
                            selectMenu: classes.selectMenu,
                            outlined: classes.selectOutline,
                        }}
                        data-testid="shipHoliday"
                        displayEmpty
                        id="shipHoliday"
                        IconComponent={KeyboardArrowDownIcon}
                        onChange={(event) => handleSelectHoliday(event.target.value)}
                        value={holidayValue}
                        variant="standard"
                    >
                        {getHolidayList()}
                    </Select>
                </FormControl>
            </Grid>
        );
    }

    return null;
};

ShipHolidaysList.propTypes = {
    shipHolidayDetails: object.isRequired,
    holidaySelected: string.isRequired,
    handleSelectHoliday: func.isRequired,
};

export default ShipHolidaysList;
